<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
import { constants } from "crypto";
import EventBus from "@/eventBus";
import accessible from '@/mixins/accessible'

export default {
  name: "Category",
  components: {
    Pagination,
    ErrorComponent,
    Alert
  },
  data() {
    return {
      ignore_duplicated: false,
      force_allow_none_store: false,
      query: "",
      storeListOrigin: [],
      ext: "",
      currentPage: 1,
      totalPage: 0,
      itemsPerPage: 10,
      list: [],
      colorList: [],
      currentSorting: "",
      availableStoreStr: "",
      stores: [],
      selectedStores: [],
      isAll: false,
      storeList: [],
      category: {
        id: "",
        name: "",
        color_code: "",
        representation_type: "COLOR",
        representation_image: "",
        ignore_duplicated: false,
        force_allow_none_store: false,
      },
      filterObj: {
        search: ""
      },
      access_right: {}
    };
  },

  mixins: [accessible],

  methods: {
    pageChange(page) {
      this.getList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(1);
    },
    getList(page) {
      this.list = [];
      this.currentPage = page;

      if (this.search) {
        this.filterObj.search = search;
      }
      this.$api
        .getAPI({
          _action: "/category/list/" + this.itemsPerPage + "/" + page,
          _body: this.filterObj
        })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.list = res.list;
          }
          if (page == 1) {
            if (res.count != null && res.count > 0) {
              this.$refs.listPagination.setTotalCount(res.count);
            } else {
              this.$refs.listPagination.setTotalCount(0);
            }
          }

          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle(
              this.$lang.messages.no_category_found
            );
          } else if (this.$refs.errorComonent.isShowMessage()) {
            this.$refs.errorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle();
        });
    },
    setAvailableStr() {
      var nAvailableStore = 0
      for(let i=0; i<this.selectedStores.length; i++){
        if(this.$_.findIndex(this.storeListOrigin, {'id': this.selectedStores[i]}) != -1){
          nAvailableStore += 1
        }
      }
      this.isAll = false
      if(nAvailableStore == this.storeListOrigin.length){
        this.isAll = true
      }
      this.availableStoreStr = "";
      if (this.selectedStores.length > 0) {
        if (this.isAll) {
          this.availableStoreStr = this.$lang.messages.available_in_all_stores;
        } else {
          if (nAvailableStore == 1) {
            this.availableStoreStr = `${this.$lang.messages.available_in} 1 ${this.$lang.messages.store.toLowerCase()}`;
          } else if(nAvailableStore > 0) {
            this.availableStoreStr =
              `${this.$lang.messages.available_in} ${nAvailableStore} ${this.$lang.messages.stores.toLowerCase()}`;
          }
        }
      }
    },
    checkUncheckStore(event) {
      this.setAvailableStr();
      if (event && !event.target.checked) {
        this.isAll = false;
      }
    },
    checkAllStores(event) {
      this.availableStoreStr = "";
      if (this.isAll) {
        for (var i = 0; i < this.storeList.length; i++) {
          if(this.selectedStores.indexOf(this.storeList[i].id) == -1){
            this.selectedStores.push(this.storeList[i].id);
          }
        }
      }else{
        for (var i = 0; i < this.storeList.length; i++) {
          this.selectedStores = this.selectedStores.filter(item => item !== this.storeList[i].id)
        }
      }
      this.setAvailableStr();
    },

    searchStores(event) {
      if(this.query == ""){
        this.storeList = this.storeListOrigin
      }else{
        this.storeList = this.$flowFilter(this.storeListOrigin, this.query);
      }
    },
    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
            this.storeListOrigin = res.list;
          }
          if (this.$route.params.id) {
            this.details(this.$route.params.id);
          } else {
            this.isAll = true;
            this.checkAllStores();
          }
        })
        .catch(e => {});
    },
    getColorList() {
      this.$api
        .getAPI({ _action: "/color/list" })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.colorList = res.list;
          }
        })
        .catch(e => {});
    },

    details(id) {
      this.category = {};
      this.$api
        .getAPI({
          _action: "/category/detail/" + id
        })
        .then(res => {
          this.ignore_duplicated = true;
          this.force_allow_none_store = true;
          this.category = res;
          if (res.stores && res.stores.length > 0) {
            this.selectedStores = []
            for (var i = 0; i < res.stores.length; i++) {
              if (res.stores[i].is_available) this.selectedStores.push(res.stores[i].store_id);
            }

            if (this.selectedStores.length == this.storeList.length) {
              this.isAll = true;
            }
          } else {
            this.selectedStores = [];
            this.isAll = false;
          }
          this.setAvailableStr();

          setTimeout(() => {
            this.selectColorCode(res.color_code, res.color_id);
          }, 100);
        });
    },

    setObj(id, name) {
      this.category.id = id;
      this.$refs.deleteCategoryAlert.message = this.$lang.messages.delete_category_message;
    },

    onChange(e) {
      let files = e.target.files;
      this.file = files[0];

      var imgname = $("#AddPhoto").val();
      this.ext = imgname.substr(imgname.lastIndexOf(".") + 1);

      if (files[0]["type"] === "image/jpeg" || files[0]["type"] === "image/png") {
        if (e.target.files && e.target.files[0]) {
          var reader = new FileReader();
          reader.onload = function(e) {
            $("#Category_img").attr("src", e.target.result);
          };
        }
        reader.readAsDataURL(e.target.files[0]);
      } else {
        this.file = null;
        this.$notify({
          group: "foo",
          text: "Please select image in correct format",
          type: "error"
        });
        return false;
      }
    },

    uploadFile(id) {
      this.$api
        .uploadImageAPI({
          _action: "/category/image/" + id,
          _key: "representation_image",
          _file: this.file
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
          document.getElementById("cancel-btn").click();
          this.getList(1);
        });
    },

    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save();
          return;
        }
      });
    },

    save() {
      if (this.selectedStores.length > 0) {
        this.category.stores = this.selectedStores;
      } else {
        this.category.stores = [];
      }
      localStorage.setItem('cacheVersion', Date.now())
      this.$api
        .postAPI({
          _action: "/category/save",
          _body: this.category,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
          if (this.category.representation_type == "IMAGE" && this.file) {
            this.uploadFile(res.id);
          } else {
            document.getElementById("cancel-btn").click();
            this.getList(1);
          }
        })
        .catch(e => {
            if (e.status == 409){
              this.$refs.duplicatedItemAlert.message = e.data.message;
              $('#duplicated-customer-modal').modal('show');
            }
            if (e.status == 406){
              this.$refs.noneCustomerStore.message = e.data.message;
              $('#none-customer-store-modal').modal('show');
            }
        });
    },
    selectColorCode(code, id) {
      this.category.color_code = code;
      $("li.color-thumb").removeClass("active");
      $("#color_" + id).addClass("active");
    },

    gotoCategoryEdit(id) {
      this.query = "";
      this.storeList = this.storeListOrigin;
      this.details(id);
      $("#AddCategory").modal("show");
    },

    deleteCategory(e) {
      if (this.category.id) {
        this.$api
          .deleteAPI({
            _action: "/category/delete/" + this.category.id
          })
          .then(res => {
            this.$refs.deleteCategoryAlert.close();
            this.$notify({
              group: "foo",
              text: res.message,
              type: "success"
            });
            this.category.id = "";
            this.getList(1);
          })
          .catch(e => {
            this.$refs.deleteCategoryAlert.close();
          });
      }
    },

    saveDuplicatedName(e){
      this.category.ignore_duplicated = true
      this.$refs.duplicatedItemAlert.close();
      this.save()
    },
    saveNoneCustomerStore(e){
      this.category.force_allow_none_store = true
      this.$refs.noneCustomerStore.close();
      this.save()
    },

    clearAddModal(e) {
      if (!this.checkPendingAccountStatus(e)) return

      $("li.color-thumb").removeClass("active");
      this.category.id = "";
      this.category.color_code = "";
      this.category.name = "";
      this.category.representation_type = "COLOR";
      this.category.representation_image = "";
      this.category.items = [];
      this.$validator.reset();
      this.errors.clear();
      this.checkAllStores();
    },
    retry() {
      this.getList(1);
    },
  },
  mounted() {
    this.getColorList();
    this.getList(1);
    this.getStoreList();

    EventBus.$on("GET_ME_SUCCESS", payload => {
      this.access_right = payload.access_right;
      this.currentUser = payload
    });

    $(".search-box a, .search-box .app-search .srh-btn").on(
      "click",
      function() {
        $(".app-search").toggle(200);
        $(".app-search input").focus();
      }
    );
  }
};
</script>

<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3 text-right">
              <button
                type="button"
                class="btn bg-white search-box border-secondary rounded-5 mr-3"
                style="height: 42px"
              >
                <a class="text-secondary waves-effect waves-dark p-0" href="javascript:void(0)">
                  <i class="fas fa-search font-16"></i>
                </a>
                <form class="app-search position-absolute" v-on:submit.prevent>
                  <input
                    type="text"
                    class="form-control"
                    v-model="filterObj.search"
                    v-bind:placeholder="$lang.messages.search_enter"
                    v-on:keyup.enter="getList(1)"
                  />
                  <a class="srh-btn">
                    <i class="ti-close"></i>
                  </a>
                </form>
              </button>
              <button v-if="!!access_right.create_items"
                @click="clearAddModal"
                class="btn btn-primary px-4"
                data-toggle="modal"
                data-target="#AddCategory"
              >+ {{$lang.messages.add_category}}</button>
            </div>

            <div class="card rounded-5">
              <div class="card-body table-responsive">
                <table class="table table-striped table-style-1">
                  <thead>
                    <tr>
                      <th scope="col">Sr.no</th>
                      <th scope="col"></th>
                      <th scope="col">{{$lang.messages.name}}</th>
                      <th scope="col" class="text-right">{{$lang.messages.action}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(category,i) in list" :key="category.id">
                      <td>{{(currentPage -1) * itemsPerPage + i +1}}</td>
                      <td v-if="category.representation_type == 'COLOR'">
                        <i
                          class="fas fa-circle"
                          v-bind:style="{ color: category.color_code, fontSize:  '35px' }"
                        ></i>
                      </td>
                      <td v-if="category.representation_type == 'IMAGE'">
                        <img
                          :src="category.representation_image"
                          width="35"
                          height="35"
                          class="rounded-circle"
                        />
                      </td>
                      <td>{{category.name}}</td>
                      <td class="text-right">
                        <a v-if="!!access_right.menu_items"
                          href="javascript:void(0)"
                          class="text-primary mr-2 font-18"
                          @click="gotoCategoryEdit(category.id)"
                        >
                          <i class="mdi mdi-pencil"></i>
                        </a>
                        <a v-if="!!access_right.menu_items"
                          href="javascript:void(0)"
                          data-toggle="modal"
                          data-target="#delete-category-modal"
                          @click="setObj(category.id, category.name)"
                        >
                          <i class="far fa-trash-alt font-20 text-danger"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <ErrorComponent @retry="retry()" ref="errorComonent" />
              </div>
            </div>

            <div class="page-bottom-pagination text-right">
              <Pagination
                @page-change="pageChange"
                @items-per-page-change="itemsPerPageChange()"
                ref="listPagination"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Box -->
    <div
      class="modal fade"
      id="AddCategory"
      tabindex="-1"
      role="dialog"
      aria-labelledby="AddCategory"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content px-lg-4 py-lg-4">
          <div class="modal-header border-0">
            <h5
              class="modal-title font-22"
            >{{category.id ? $lang.messages.update_category : $lang.messages.create_category}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body form-style">
            <div class="row mb-4">
              <div class="col-lg-12">
                <label for>{{$lang.messages.category_name}}</label>
                <span style="color:#ff0000">*</span>
                <input
                  name="name"
                  v-model="category.name"
                  v-validate="'required|max:300'"
                  class="form-control"
                  maxlength="300"
                  :class="{'input': true, 'is-danger': errors.has('name') }"
                  type="text"
                  v-bind:placeholder="$lang.messages.name"
                />
                <i v-show="errors.has('name')" class="fa fa-warning"></i>
                <span
                  v-show="errors.has('name')"
                  class="help is-danger"
                >{{$lang.messages.please_enter_valid_name}}</span>
              </div>

              <div class="col-lg-12">
                <div class="card rounded-5 p-3 border">
                  <div class="card-body form-style">
                    <div class="pink-tape mb-4">
                      <h3
                        class="font-22 mb-0 font-weight-normal"
                      >{{$lang.messages.representation_on_pos}}</h3>
                    </div>
                    <div class="row px-3">
                      <div class="col-lg-12 mb-3 border-bottom">
                        <div class="custom-control custom-radio d-inline-block mb-2">
                          <input
                            type="radio"
                            class="custom-control-input"
                            id="ColorShape"
                            name="representation"
                            v-model="category.representation_type"
                            value="COLOR"
                            required
                          />
                          <label
                            class="custom-control-label"
                            for="ColorShape"
                          >{{$lang.messages.color_and_shape}}</label>
                        </div>
                        <div
                          class="color-thumb-wrap mt-4"
                          v-if="category.representation_type == 'COLOR'"
                        >
                          <ul class="color-list list-unstyled list-inline" id="SelectColor">
                            <li
                              class="color-thumb"
                              v-for="color in colorList"
                              @click="selectColorCode(color.code, color.id)"
                              :id="'color_'  +color.id"
                              :key="color.id"
                              v-bind:style="{ backgroundColor: color.code }"
                            >&nbsp;</li>
                          </ul>
                        </div>
                      </div>
                      <div class="col-lg-8">
                        <div class="custom-control custom-radio d-inline-block mb-3">
                          <input
                            type="radio"
                            class="custom-control-input"
                            id="image"
                            name="representation"
                            v-model="category.representation_type"
                            value="IMAGE"
                            required
                          />
                          <label class="custom-control-label" for="image">{{$lang.messages.image}}</label>
                        </div>

                        <div class v-if="category.representation_type == 'IMAGE'">
                          <div class="mb-2">
                            <img
                              :src="category.representation_image"
                              class="img-fluid w-50"
                              alt="image thumb"
                              id="Category_img"
                              width="180"
                            />
                          </div>
                          <button
                            type="button"
                            class="btn px-3 upload-img-merge-btn rounded-8 btn-outline-primary w-50 text-capitalize"
                          >
                            {{$lang.messages.upload_image}}
                            <input
                              type="file"
                              class="btn upload-img"
                              id="AddPhoto"
                              accept="image/*"
                              @change="onChange($event)"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-lg-12">
                <div class="card rounded-5 pt-1 border">
                  <div
                    class="card-header bg-white border-bottom cursor-pointer px-lg-5 px-4"
                    data-toggle="collapse"
                    data-target=".stores-list"
                    aria-expanded="true"
                    aria-controls="multiCollapseExample1 multiCollapseExample2"
                  >
                    <h4 class="font-20 d-inline">
                      {{$lang.messages.store}}
                      <span class="font-16 ml-3 d-inline"
                      >{{availableStoreStr}}</span>
                    </h4>
                    <img src="/images/down-arrow.svg" width="15" class="d-inline float-right mt-1" />
                  </div>
                  <div class="card-body form-style collapse stores-list px-lg-5 px-4 show">

                    <form @submit.prevent="searchStores($event)" class="mb-3">
                      <div class="input-group input-group-lg">
                        <span class="input-group-append">
                          <button class="btn btn-outline-secondary" type="submit" style="height: 40px;border-color: #c5c5c5;">
                              <i class="fa fa-search"></i>
                          </button>
                        </span>
                        <input
                            type="text"
                            class="form-control input-lg"
                            v-model="query"
                            v-on:input="searchStores($event)"
                            :placeholder="$lang.messages.search_store"/>
                      </div>
                    </form>

                    <div class="custom-control custom-checkbox" v-if="query == ''">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-1"
                        v-model="isAll"
                        @change="checkAllStores($event)"
                      />
                      <label
                        class="custom-control-label text-dark ml-2"
                        for="checkbox-1"
                      >{{$lang.messages.select_all_stores}}</label>
                    </div>
                    <div class="dropdown-divider" style="border-top: 1px solid #c3c3c3;" v-if="query == ''"></div>
                    <div>
                      <div
                        class="custom-control custom-checkbox mb-3"
                        v-for="store in storeList"
                        :key="store.id"
                      >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :value="store.id"
                          :id="'type_'  +store.id"
                          v-model="selectedStores"
                          @change="checkUncheckStore($event)"
                        />

                        <label
                          class="custom-control-label text-dark ml-2"
                          :for="'type_' +store.id"
                        >{{store.name}}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer border-0 justify-content-center">
            <button
              type="submit"
              class="btn btn-primary mr-3"
              @click="validateForm()"
              id="save-btn"
            >{{$lang.messages.save_btn_text}}</button>
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-outline-primary"
              id="cancel-btn"
            >{{$lang.messages.cancel_btn_text}}</button>
          </div>
        </div>
      </div>
    </div>

    <Alert
      @rightButtonEvent="deleteCategory($event)"
      v-bind:title="$lang.messages.delete_category"
      ref="deleteCategoryAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="delete-category-modal"
    />
    <Alert
      @rightButtonEvent="saveDuplicatedName($event)"
      v-bind:title="$lang.messages.duplicated_category"
      ref="duplicatedItemAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="duplicated-customer-modal"
    />
    <Alert
      @rightButtonEvent="saveNoneCustomerStore($event)"
      v-bind:title="$lang.messages.category"
      ref="noneCustomerStore"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="none-customer-store-modal"
    />
  </div>
</template>
